import Model from "@/models/Model"

export default class ARepackingParents extends Model {
    resource() {
        return "repacking_parents"
    }
}